import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FlightService } from '../../../flight.service';
import { SubSink } from 'subsink';
import { ActivatedRoute } from '@angular/router';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';

@Component({
    selector: 'app-booking-fare-summary',
    templateUrl: './booking-fare-summary.component.html',
    styleUrls: ['./booking-fare-summary.component.scss']
})
export class BookingFareSummaryComponent implements OnInit, OnDestroy {

    @Input() flight: any;
    @Input() showFlightDetails:boolean = true;
    @Input() convenienceFee:any;
    @Input() showTotalDisplayFare: any;
    isCollapsedGst = true;
    isCollapsedServiceReqs = true;
    adultCount = 0;
    childCount = 0;
    infantCount = 0;
    baggageFee = 0.00;
    mealFee = 0.00;
    seatFee = 0.00;
    totalDisplayFare = 0.00;
    isBaggaeProtected: boolean = false;
    baggageProtectedData: any;
    flightDetails: any;
    airline_logo: any;
    appReference: string;
    promocode:any;
    discount_value:number= 0.00;

    protected subs = new SubSink();
    constructor(
        private flightService: FlightService,
        private cdRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private apiHandlerService: ApiHandlerService,
        private swalService: SwalService
    ) { }

    ngOnInit() {
        // this.flightService.bookingFlightData.subscribe(res => {
        //     this.flight = res;
        //     console.log("flight",this.flight)
        //   });
        this.activatedRoute.queryParams.subscribe(params => {
            if (params && params.AppReference)
                this.appReference = (params.AppReference).replace("/", "");
        })
        if (window.location.href.includes("flight/payment-details") && this.appReference && this.appReference != "") {
            this.getFareSummery(this.appReference);
        }
        this.airline_logo = this.flightService.airline_logo;
        this.subs.sink = this.flightService.baggageFees.subscribe(res => {
            if (res && Object.keys(res).length>0) {
            this.baggageFee=res['baggageFee'];
            this.totalDisplayFare=0;
            if (this.flight) {
            this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare) + Number(this.baggageFee) + Number(this.mealFee) + Number(this.seatFee);
            }
        }
            else{
                if (this.flight) {
                this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare);
                }
            }
            this.cdRef.detectChanges();
        });
        this.subs.sink = this.flightService.mealFees.subscribe(res => {
            if (res && Object.keys(res).length > 0) {
                this.mealFee = res['mealFee'];
                this.totalDisplayFare = 0;
                if (this.flight) {
                    this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare) + Number(this.baggageFee) + Number(this.mealFee) + Number(this.seatFee);
                }
            }
            else {
                if (this.flight) {
                    this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare);
                }
            }
            this.cdRef.detectChanges();
        });
        this.subs.sink = this.flightService.seatFees.subscribe(res => {
            if (res && Object.keys(res).length > 0) {
                this.seatFee = res['seatFee'];
                this.totalDisplayFare = 0;
                if (this.flight) {
                    this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare) + Number(this.baggageFee) + Number(this.mealFee) + Number(this.seatFee);
                }
            }
            else {
                if (this.flight) {
                    this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare);
                }
            }
            this.cdRef.detectChanges();
        });
        this.subs.sink = this.flightService.extraFees.subscribe(res => {
            if (res && Object.keys(res).length>0) {
                this.baggageFee = res['baggageFee'] || 0;
                this.mealFee = res['mealFee'] || 0;
                this.seatFee = res['seatFee'] || this.seatFee;
                if (this.flight) {
                    this.totalDisplayFare = Number(this.flight.Price.TotalDisplayFare) + Number(this.baggageFee) + Number(this.mealFee) + Number(this.seatFee);
                }
            }
        });

        this.subs.sink = this.flightService.flightPromocode.subscribe(res => {
            if (res && Object.keys(res).length > 0) {
                this.promocode = res['promocode'];
                if (this.promocode && this.promocode != "") {
                    if (this.promocode.discount_type == "percentage") {
                        let amount: number
                        amount = (this.promocode.discount_value / 100);
                        this.discount_value = this.flight.Price.TotalDisplayFare * amount;
                    }
                    if (this.promocode.discount_type == "plus") {
                        this.discount_value = this.promocode.discount_value;
                    }
                }
                else {
                    this.discount_value = 0;
                }

            }
            this.cdRef.detectChanges();
        });

        this.getBaggageProtectionData();
        this.cdRef.detectChanges();
    }

    getBaggageProtectionData() {
        this.subs.sink = this.flightService.baggeProtectionData.subscribe(resp => {
            if (resp.isProtected && resp.data) {
                this.isBaggaeProtected = true;
                this.baggageProtectedData = resp.data;
                this.totalDisplayFare = this.totalDisplayFare + (this.adultCount + this.childCount + this.infantCount) * this.baggageProtectedData.Total_Price;
                this.cdRef.detectChanges();
            } else {
                this.isBaggaeProtected = false;
            }
        })
    }
    isAdult(flight: any) {
        if (flight) {
            const result = flight['Price']['PassengerBreakup'].hasOwnProperty('ADT');
            if (result) {
                this.adultCount = flight.Price.PassengerBreakup.ADT.PassengerCount;
            }
            return result;
        }
    }

    isChild(flight: any) {
        if (flight) {
            const result = flight['Price']['PassengerBreakup'].hasOwnProperty('CHD');
            if (result) {
                this.childCount = flight['Price']['PassengerBreakup'].CHD.PassengerCount;
            }
            return result;
        }
    }

    isInfant(flight: any) {
        if (flight) {
            const result = flight['Price']['PassengerBreakup'].hasOwnProperty('INF');
            if (result) {
                this.infantCount = flight['Price']['PassengerBreakup'].INF.PassengerCount;
            }
            return result;
        }
    }

    getFareSummery(appReference) {
        let req = { 'AppReference': this.appReference };
        this.apiHandlerService.apiHandler('flightVoucher', 'post', '', '', req).subscribe(res => {
            if (res && res.data) {
                this.flight = [];
                this.flight.Price = res.data[0].TotalFarePriceBreakUp;
                this.flight.FlightItineraries = res.data[0].FlightItineraries;
                this.cdRef.detectChanges();
            }

        }, (err) => {
            this.swalService.alert.oops(err.error.Message);
        });
    }

    getTime(date: any) {
        return date.substr(11, 5);
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

}
